import { useEffect } from 'react';
import { useAuth } from 'react-oidc-context';
import { useNavigate } from 'react-router-dom';
import { routes } from '@config/routes';

/**
 * Lands here after the Cognito hosted-UI redirect. react-oidc-context performs the PKCE code
 * exchange automatically on mount; once a user is present (or an error occurs) we leave the callback
 * route for the dashboard. `onSigninCallback` in oidcConfig already strips the `?code=...` query.
 */
export function AuthCallbackPage() {
  const auth = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (auth.isLoading) return;
    if (auth.isAuthenticated || auth.error) navigate(routes.dashboard, { replace: true });
  }, [auth.isLoading, auth.isAuthenticated, auth.error, navigate]);

  return (
    <div className="flex h-screen w-full items-center justify-center">
      <p className="text-text-muted">
        {auth.error ? `Sign-in error: ${auth.error.message}` : 'Completing sign-in…'}
      </p>
    </div>
  );
}
